export const PUBLIC_MEDIA_BASE_URL =
  'https://image-effects-gallery-wangjs-jacky.oss-cn-hangzhou.aliyuncs.com/media/';
